import {
  Alert,
  Col,
  message,
  PageHeader,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tabs,
  Tag,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ButtonItem,
  cuentaMask,
  dineroDisabledMask,
  ErrorItem,
  Form,
  FormItem,
  RangePickerItem,
  SelectInsumosItem,
  SelectItem,
  TableItem,
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { descargarExcel, descargarPdf } from "./exportarConversionVentas";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

/** Verde si ya se convirtio todo, azul si va parcial, rojo si no se ha vendido nada. */
const porcentajeTag = (valor) =>
  valor == null ? (
    "-"
  ) : (
    <Tag color={valor >= 100 ? "green" : valor > 0 ? "blue" : "red"}>{`${valor}%`}</Tag>
  );

/** Cantidades sin ceros de relleno: 12 y no 12.000000, pero 0.5 se conserva. */
const cantidadTexto = (valor) =>
  valor == null ? "" : Number(valor).toLocaleString("es-MX", { maximumFractionDigits: 6 });

/**
 * Pantalla compartida de los reportes de conversion: "Cotizacion Vs Ventas" y
 * "Pedido Vs Ventas".
 *
 * Los dos reportes son la misma pantalla con otro documento de origen, asi que la logica vive
 * aqui una sola vez y cada reporte es un envoltorio que le pasa su `config`
 * (ver `ReporteCotizacionVsVentas.js` y `ReportePedidoVsVentas.js`).
 *
 * Contesta, por proyecto, cuanto se cotizo/pidio contra cuanto acabo siendo venta. Hay dos
 * montos y son distintos a proposito:
 *   - "Convertido": prorrateo por renglon. Es el que manda para el % de conversion.
 *   - "Facturado": el subtotal real de las ventas ligadas. En el resumen por proyecto va
 *     deduplicado (una venta que consumio dos documentos se cuenta una vez).
 *
 * Las tablas en pantalla llevan solo las columnas indispensables a proposito: `TableItem` fuerza
 * `tableLayout: fixed` e ignora la prop `scroll`, asi que una tabla ancha se comprime en vez de
 * desplazarse. El detalle completo va al Excel.
 */
class ReporteConversionVentas extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    filas: [],
    resumen: [],
    resumenInsumos: [],
    // insumoId -> fila de `resumenInsumos`. Los renglones del detalle llegan sin clave ni
    // descripcion y se resuelven aqui.
    mapaInsumos: new Map(),
    filtroInsumos: 0,
    totales: null,
    objetoClientes: null,
    objetoUsuarios: null,
    objetoProyectos: null,
    objetoUniadesDeNegocio: null,
    filtrosConsultados: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });

    // Cada catalogo lleva su propio .catch(): sin el, uno que falle rechaza el Promise.all,
    // corta el componentDidMount y la consulta inicial nunca se lanza — la pantalla se queda
    // con el spinner puesto para siempre y sin ningun mensaje.
    await Promise.all([
      axios
        .post(
          "clientes/selectClientes",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoClientes: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              )),
            });
          }
        })
        .catch(() => {}),

      axios
        .post(
          "usuarios/selectUsuariosEmpresa",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoUsuarios: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {`${value.nombre} ${value.apellidoPaterno} ${value.apellidoMaterno}`}
                </Option>
              )),
            });
          }
        })
        .catch(() => {}),

      axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoProyectos: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              )),
            });
          }
        })
        .catch(() => {}),

      axios
        .post(
          "unidadesdenegocio/selectUnidadesDeNegocio",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoUniadesDeNegocio: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {`${cuentaMask(
                    value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5
                  )} - ${value.nombre}`}
                </Option>
              )),
            });
          }
        })
        .catch(() => {}),
    ]);

    this.consultarReporte({
      periodo: [moment().subtract(1, "month"), moment()],
      clientes: 0,
      vendedores: 0,
      filtrarProyecto: 0,
      conversion: 0,
      [this.props.config.campoEstado]: 5,
    });
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    axios
      .post(
        `reportesDeVentas/${this.props.config.endpoint}`,
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const resumenInsumos = res.data.resumenInsumos || [];
          this.setState({
            loading: false,
            filas: res.data.filas || [],
            resumen: res.data.resumen || [],
            resumenInsumos,
            mapaInsumos: new Map(resumenInsumos.map((insumo) => [insumo.insumoId, insumo])),
            filtroInsumos: res.data.filtroInsumos || 0,
            totales: res.data.totales,
            filtrosConsultados: values,
          });
        } else {
          // El backend manda `message` cuando rechaza por tope de documentos o de ventas:
          // hay que mostrarlo, es lo que le dice al usuario que acote el periodo.
          message.error(
            res.data?.message || "Ha sucedido un error y no se cargo bien el reporte"
          );
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error de conexión");
        this.setState({ loading: false });
      });
  }

  /** Resumen legible de los filtros, para el encabezado del Excel y del PDF. */
  descripcionFiltros() {
    const filtros = this.state.filtrosConsultados;
    if (!filtros) return "";
    const config = this.props.config;

    const partes = [];
    if (filtros.periodo?.length === 2) {
      partes.push(
        `Del ${moment(filtros.periodo[0]).format("DD/MM/YYYY")} al ${moment(
          filtros.periodo[1]
        ).format("DD/MM/YYYY")}`
      );
    }

    const estado = config.opcionesEstado.find(
      (opcion) => opcion.value === filtros[config.campoEstado]
    );
    if (estado) partes.push(estado.label);

    const ETIQUETA_CONVERSION = {
      0: "Todas",
      1: "Solo las que pasaron a venta",
      2: "Solo las que NO pasaron a venta",
    };
    if (ETIQUETA_CONVERSION[filtros.conversion]) {
      partes.push(ETIQUETA_CONVERSION[filtros.conversion]);
    }

    if (filtros.clientes?.length > 0) partes.push(`${filtros.clientes.length} cliente(s)`);
    if (filtros.vendedores?.length > 0) partes.push(`${filtros.vendedores.length} vendedor(es)`);
    if (filtros.insumos?.length > 0) partes.push(`${filtros.insumos.length} insumo(s)`);
    if (filtros.filtrarProyecto === 1) partes.push("Filtrado por proyecto");
    if (filtros.filtrarProyecto === 2) partes.push("Filtrado por unidad de negocio");

    return partes.join(" - ");
  }

  parametrosExportacion() {
    return {
      datos: this.state.filas,
      resumen: this.state.resumen,
      resumenInsumos: this.state.resumenInsumos,
      mapaInsumos: this.state.mapaInsumos,
      totales: this.state.totales,
      empresaNombre: this.props.empresa,
      descripcionFiltros: this.descripcionFiltros(),
    };
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const config = this.props.config;
    const totales = this.state.totales;

    const columnasResumen = [
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        buscar: "proyecto",
        width: "26%",
      },
      {
        title: config.plural,
        dataIndex: "documentos",
        key: "documentos",
        width: "10%",
        align: "right",
        sorter: (a, b) => a.documentos - b.documentos,
      },
      {
        title: "Convertidos",
        dataIndex: "documentosConvertidos",
        key: "documentosConvertidos",
        width: "11%",
        align: "right",
        sorter: (a, b) => a.documentosConvertidos - b.documentosConvertidos,
      },
      {
        title: config.etiquetaMonto,
        dataIndex: "cotizadoMxn",
        key: "cotizadoMxn",
        width: "15%",
        align: "right",
        sorter: (a, b) => a.cotizadoMxn - b.cotizadoMxn,
        render: (valor) => dineroDisabledMask(valor),
      },
      {
        title: "Convertido",
        dataIndex: "convertidoMxn",
        key: "convertidoMxn",
        width: "15%",
        align: "right",
        sorter: (a, b) => a.convertidoMxn - b.convertidoMxn,
        render: (valor) => dineroDisabledMask(valor),
      },
      {
        title: "% Conv.",
        dataIndex: "porcentajeConversion",
        key: "porcentajeConversion",
        width: "9%",
        align: "right",
        sorter: (a, b) => (a.porcentajeConversion || 0) - (b.porcentajeConversion || 0),
        render: (valor) => porcentajeTag(valor),
      },
      {
        title: "Facturado",
        dataIndex: "facturadoMxn",
        key: "facturadoMxn",
        width: "14%",
        align: "right",
        sorter: (a, b) => a.facturadoMxn - b.facturadoMxn,
        render: (valor) => dineroDisabledMask(valor),
      },
    ];

    const columnasDetalle = [
      { title: "Folio", dataIndex: "folio", key: "folio", buscar: "folio", width: "10%" },
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        width: "8%",
        sorter: (a, b) => new Date(a.fechaOrden || 0) - new Date(b.fechaOrden || 0),
      },
      { title: "Cliente", dataIndex: "cliente", key: "cliente", buscar: "cliente", width: "16%" },
      { title: "Proyecto", dataIndex: "proyecto", key: "proyecto", buscar: "proyecto", width: "14%" },
      { title: "Estado", dataIndex: "estado", key: "estado", width: "9%" },
      // En pantalla los importes van en MXN, para que el detalle sea comparable con el resumen
      // y entre documentos de monedas distintas. El Excel si lleva ademas la moneda original.
      {
        title: `${config.etiquetaMonto} (MXN)`,
        dataIndex: "cotizadoMxn",
        key: "cotizadoMxn",
        width: "12%",
        align: "right",
        sorter: (a, b) => a.cotizadoMxn - b.cotizadoMxn,
        render: (valor) => dineroDisabledMask(valor),
      },
      {
        title: "Convertido (MXN)",
        dataIndex: "convertidoMxn",
        key: "convertidoMxn",
        width: "12%",
        align: "right",
        sorter: (a, b) => a.convertidoMxn - b.convertidoMxn,
        render: (valor) => dineroDisabledMask(valor),
      },
      {
        title: "% Conv.",
        dataIndex: "porcentajeConversion",
        key: "porcentajeConversion",
        width: "8%",
        align: "right",
        sorter: (a, b) => (a.porcentajeConversion || 0) - (b.porcentajeConversion || 0),
        render: (valor) => porcentajeTag(valor),
      },
      {
        title: "Ventas",
        dataIndex: "ventas",
        key: "ventas",
        width: "11%",
        render: (valor, fila) => (
          <>
            {fila.convertida ? valor || `${fila.ventasCount} venta(s)` : <Tag>Sin venta</Tag>}
            {/* La cancelacion legada borra el consumo sin desligar la venta: sin este aviso,
                un "Convertido = 0" con ventas ligadas parece un error del reporte. */}
            {fila.alerta === "sinConsumoRegistrado" && (
              <Tag color="orange" style={{ marginLeft: 4 }}>
                Sin consumo
              </Tag>
            )}
          </>
        ),
      },
    ];

    // Una equivalencia sale en su propio renglon: su unidad es otra.
    const columnasInsumos = [
      { title: "Clave", dataIndex: "clave", key: "clave", buscar: "clave", width: "11%" },
      {
        title: "Descripcion",
        dataIndex: "descripcion",
        key: "descripcion",
        buscar: "descripcion",
        width: "25%",
      },
      { title: "Unidad", dataIndex: "unidad", key: "unidad", width: "8%" },
      {
        title: config.etiquetaCantidad,
        dataIndex: "cantidad",
        key: "cantidad",
        width: "10%",
        align: "right",
        sorter: (a, b) => a.cantidad - b.cantidad,
        render: (valor) => cantidadTexto(valor),
      },
      {
        title: "Cant. vendida",
        dataIndex: "cantidadConvertida",
        key: "cantidadConvertida",
        width: "10%",
        align: "right",
        sorter: (a, b) => a.cantidadConvertida - b.cantidadConvertida,
        render: (valor) => cantidadTexto(valor),
      },
      {
        title: "% Conv.",
        dataIndex: "porcentajeConversion",
        key: "porcentajeConversion",
        width: "8%",
        align: "right",
        sorter: (a, b) => (a.porcentajeConversion || 0) - (b.porcentajeConversion || 0),
        render: (valor) => porcentajeTag(valor),
      },
      {
        title: `${config.etiquetaMonto} (MXN)`,
        dataIndex: "cotizadoMxn",
        key: "cotizadoMxn",
        width: "14%",
        align: "right",
        sorter: (a, b) => a.cotizadoMxn - b.cotizadoMxn,
        render: (valor) => dineroDisabledMask(valor),
      },
      {
        title: "Convertido (MXN)",
        dataIndex: "convertidoMxn",
        key: "convertidoMxn",
        width: "14%",
        align: "right",
        sorter: (a, b) => a.convertidoMxn - b.convertidoMxn,
        render: (valor) => dineroDisabledMask(valor),
      },
    ];

    // Tabla anidada del detalle: va con el `Table` de antd directo porque `TableItem` fuerza su
    // propia paginacion.
    const insumoDe = (renglon) => this.state.mapaInsumos.get(renglon.insumoId) || {};
    const columnasRenglones = [
      {
        title: "Clave",
        key: "clave",
        width: "12%",
        render: (_, renglon) => insumoDe(renglon).clave,
      },
      {
        title: "Descripcion",
        key: "descripcion",
        width: "28%",
        render: (_, renglon) => {
          const insumo = insumoDe(renglon);
          return insumo.unidad ? `${insumo.descripcion} (${insumo.unidad})` : insumo.descripcion;
        },
      },
      {
        title: config.etiquetaCantidad,
        dataIndex: "cantidad",
        key: "cantidad",
        width: "9%",
        align: "right",
        render: (valor) => cantidadTexto(valor),
      },
      {
        title: "Vendida",
        dataIndex: "cantidadConvertida",
        key: "cantidadConvertida",
        width: "9%",
        align: "right",
        render: (valor) => cantidadTexto(valor),
      },
      {
        title: "Pendiente",
        dataIndex: "cantidadPendiente",
        key: "cantidadPendiente",
        width: "9%",
        align: "right",
        render: (valor) => cantidadTexto(valor),
      },
      {
        title: `${config.etiquetaMonto} (MXN)`,
        dataIndex: "cotizadoMxn",
        key: "cotizadoMxn",
        width: "12%",
        align: "right",
        render: (valor) => dineroDisabledMask(valor),
      },
      {
        title: "Convertido (MXN)",
        dataIndex: "convertidoMxn",
        key: "convertidoMxn",
        width: "12%",
        align: "right",
        render: (valor) => dineroDisabledMask(valor),
      },
      {
        title: "% Conv.",
        dataIndex: "porcentajeConversion",
        key: "porcentajeConversion",
        width: "9%",
        align: "right",
        render: (valor) => porcentajeTag(valor),
      },
    ];

    return (
      <>
        <Form
          ref={this.formRef}
          name={config.nombreFormulario}
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title={`Reporte ${config.titulo}`}
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.filas.length > 0 && (
                    <ButtonItem
                      blanco
                      onClick={() => descargarExcel(this.parametrosExportacion(), config)}
                      icon={<FileExcelOutlined />}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.filas.length > 0 && (
                    <ButtonItem
                      blanco
                      onClick={() => descargarPdf(this.parametrosExportacion(), config)}
                      icon={<FilePdfOutlined />}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem type="primary" htmlType="submit">
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Clientes">
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Vendedores">
                  <FormItem name="vendedores" margin noStyle>
                    <SelectItem width="90%" mode="multiple" placeholder="Vendedores">
                      {this.state.objetoUsuarios}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem name="filtrarProyecto" required noStyle initialValue={0}>
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Ninguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto = getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem width="90%" placeholder="Proyectos" mode="multiple">
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem width="90%" placeholder="Unidades de Negocio">
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          return null;
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="6" key="6" forceRender tab="Insumos">
                  <FormItem name="insumos" margin noStyle>
                    <SelectInsumosItem
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                      mode="multiple"
                      width="90%"
                      placeholder="Insumos"
                      tiposInsumos="venta"
                    />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Opciones">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={12}>
                      <FormItem
                        label="Conversion"
                        name="conversion"
                        required
                        initialValue={0}
                        style={{ marginBottom: 0 }}
                      >
                        <SelectItem placeholder="Filtrar Por">
                          <Option default value={0}>
                            Todas
                          </Option>
                          <Option value={1}>Solo las que pasaron a venta</Option>
                          <Option value={2}>Solo las que NO pasaron a venta</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        label={config.etiquetaFiltroEstado}
                        name={config.campoEstado}
                        required
                        initialValue={5}
                        style={{ marginBottom: 0 }}
                      >
                        <SelectItem placeholder="Filtrar Por">
                          {config.opcionesEstado.map((opcion) => (
                            <Option value={opcion.value} key={opcion.value}>
                              {opcion.label}
                            </Option>
                          ))}
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>

            {totales && (
              <div
                style={{
                  backgroundColor: "white",
                  padding: 15,
                  marginTop: 10,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <Row gutter={[16, 8]}>
                  <Col span={5}>
                    <div style={{ color: "#8c8c8c", fontSize: 12 }}>{config.plural}</div>
                    <div style={{ fontSize: 20, fontWeight: 600 }}>
                      {totales.documentos.toLocaleString("es-MX")}
                      <span style={{ fontSize: 13, color: "#8c8c8c" }}>
                        {` / ${totales.documentosConvertidos.toLocaleString("es-MX")} con venta`}
                      </span>
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ color: "#8c8c8c", fontSize: 12 }}>{config.etiquetaMonto}</div>
                    <div style={{ fontSize: 20, fontWeight: 600 }}>
                      {dineroDisabledMask(totales.cotizadoMxn)}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ color: "#8c8c8c", fontSize: 12 }}>Convertido a venta</div>
                    <div style={{ fontSize: 20, fontWeight: 600, color: "#00BFD6" }}>
                      {dineroDisabledMask(totales.convertidoMxn)}
                    </div>
                  </Col>
                  <Col span={4}>
                    <div style={{ color: "#8c8c8c", fontSize: 12 }}>% Conversion</div>
                    <div style={{ fontSize: 20, fontWeight: 600, color: "#00BFD6" }}>
                      {totales.porcentajeConversion != null
                        ? `${totales.porcentajeConversion}%`
                        : "-"}
                    </div>
                  </Col>
                  <Col span={5}>
                    <div style={{ color: "#8c8c8c", fontSize: 12 }}>Facturado en ventas</div>
                    <div style={{ fontSize: 20, fontWeight: 600 }}>
                      {dineroDisabledMask(totales.facturadoMxn)}
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            <Alert
              style={{ marginTop: 10 }}
              type="info"
              showIcon
              message={
                `"Convertido" es la parte de cada ${config.singular.toLowerCase()} que se ` +
                "consumio en ventas directas (prorrateo por renglon). " +
                `"Facturado" es el importe completo de esas ventas: en el resumen por proyecto ` +
                "se cuenta una sola vez aunque la venta haya consumido varios documentos. " +
                "Los montos del resumen estan en MXN; el detalle muestra tambien la moneda original."
              }
              description={
                <>
                  <div>
                    {"Por insumo, \"Vendida\" es la cantidad consumida por ventas directas. " +
                      "Un insumo vendido en otra presentacion (equivalencia) sale en su propio " +
                      "renglon, y el \"Facturado\" no se desglosa por insumo."}
                  </div>
                  {this.state.filtroInsumos > 0 && (
                    <div style={{ marginTop: 4, fontWeight: 600 }}>
                      {"Con filtro de insumo: los montos por documento y por proyecto son del " +
                        "documento completo; las vistas por insumo solo incluyen los insumos " +
                        "elegidos."}
                    </div>
                  )}
                </>
              }
            />

            <div style={{ marginTop: 10 }}>
              <h2 style={{ marginBottom: 5 }}>Resumen por proyecto</h2>
              <TableItem
                rowKey={(value) => value.proyectoId}
                columns={columnasResumen}
                dataSource={this.state.resumen}
                size="small"
                defaultPageSize={20}
              />
            </div>

            <div style={{ marginTop: 10 }}>
              <h2 style={{ marginBottom: 5 }}>Resumen por insumo</h2>
              <TableItem
                rowKey={(value) => value.insumoId}
                columns={columnasInsumos}
                dataSource={this.state.resumenInsumos}
                size="small"
                defaultPageSize={20}
              />
            </div>

            <div style={{ marginTop: 10 }}>
              <h2 style={{ marginBottom: 5 }}>{`Detalle por ${config.singular.toLowerCase()}`}</h2>
              <TableItem
                onRow={(record) => ({
                  onDoubleClick: () =>
                    this.props.history.push(config.rutaVer, { id: record._id }),
                })}
                expandable={{
                  rowExpandable: (fila) => fila.renglones?.length > 0,
                  expandedRowRender: (fila) => (
                    <Table
                      rowKey={(_, indice) => `${fila._id}_${indice}`}
                      columns={columnasRenglones}
                      dataSource={fila.renglones}
                      size="small"
                      pagination={false}
                    />
                  ),
                }}
                rowKey={(value) => value._id}
                columns={columnasDetalle}
                dataSource={this.state.filas}
                size="small"
                defaultPageSize={50}
              />
            </div>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresa: state.empresa.nombre,
});

export default connect(mapStateToProps)(ReporteConversionVentas);
